import React from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';

const SupportContact = () => {
  return (
    <motion.div
      className="fixed bottom-6 left-6 z-40 flex items-center gap-2 px-3 py-2 bg-zinc-800/80 text-zinc-300 rounded-lg shadow-lg backdrop-blur-sm border border-zinc-700/50"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, duration: 0.3, ease: 'easeOut' }}
    >
      <Mail className="w-4 h-4" />
      <span className="text-xs font-medium">info@echokit.online</span>
    </motion.div>
  );
};

export default SupportContact;
